export const TAB_NAMES = {
    MonthlyActiveUsers: "MonthlyActiveUsers",
    DailyActiveUsers: "DailyActiveUsers",
    WeeklyActiveUsers: "WeeklyActiveUsers",
    DailyStickiness: "DailyStickiness",
};
export const ENGAGEMENT_TAB_MONTHLY = "MonthlyActiveUsers";
